import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { IconGeneralNoImage } from 'nicollet-icons-react';

const FallBackImageWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const FallbackImage = ({
  'data-test': testId
}) => jsx(FallBackImageWrapper, Object.assign({
  "data-test": testId
}, {
  children: jsx(IconGeneralNoImage, {
    "data-test": testId && `${testId}-fallback`,
    height: "100%",
    width: "100%"
  }, void 0)
}), void 0);

FallbackImage.displayName = 'FallbackImage';

export { FallBackImageWrapper, FallbackImage };
